import { TIMEZONE } from "../common/const";
import type { timezoneType } from '../../interface/ITimezone';
import { DateTime } from "luxon";

let luxonDateTime: any = null;

const getLuxonDateTime = async () => {
  if(luxonDateTime) return luxonDateTime;

  const { DateTime } = await import(/* 
    webpackChunkName: "luxon"
  */ `luxon`);

  luxonDateTime = DateTime;

  return luxonDateTime;
};

const setLuxonDateTime = async () => {
  luxonDateTime = await getLuxonDateTime();
};

const setDateByTimezone = (timestamp: number, timezoneType: timezoneType) => {
  return luxonDateTime?.fromMillis(timestamp, { 
    locale: 'en-US',
    zone: TIMEZONE[timezoneType] 
  });
};

const changeDateByTimezone = (dateTime: DateTime, hour: number, minute: number, timezoneType: timezoneType) => {
  const { year, month, day } = dateTime;
  const newDateTime = luxonDateTime?.local(year, month, day, hour, minute, {
    locale: 'en-US',
    zone: TIMEZONE[timezoneType]
  });

  return newDateTime.toMillis();
};

const getDayPeriod = (dateTime: DateTime) => {
  const hour = dateTime?.hour || 0;
  const isPM = hour > 12;
  return {
    dayPeriod: isPM ? 'PM' : 'AM',
    dayPeriodHour: isPM ? hour % 12 : hour
  };
};

export {
  setLuxonDateTime,
  setDateByTimezone,
  changeDateByTimezone,
  getDayPeriod
};